import { combineReducers } from 'redux';

import actionTypes from '../actionTypes';

import appliedReducer from './applied';
import currentReducer from './current';
import defaults from './defaults';
import selectors from './selectors';

const reportCategoryReducer = (state = defaults.reportCategory, action) => {
    switch (action.type) {
        case actionTypes.RESET_PLAYERS_AND_TEAMS_STATE:
            return selectors.computeReportCategory(action.payload.state);
        default:
            return state;
    }
};

const reducer = combineReducers({
    applied: appliedReducer,
    current: currentReducer,
    reportCategory: reportCategoryReducer,
});

export default reducer;
